import { combineReducers, createStore, applyMiddleware } from 'redux';
import { createStateSyncMiddleware, initStateWithPrevTab, withReduxStateSync } from 'redux-state-sync';

// Actions

const SET_LOGIN = 'SET_LOGIN';
const SET_LOGOUT = 'SET_LOGOUT';
const SET_TOKEN ="SET_TOKEN";

export const setLogin = () => {
 return { type: SET_LOGIN };
}

export const setLogout = () => {
 return { type: SET_LOGOUT };
}

export const setToken = token => {
 return { type: SET_TOKEN, token };
}

// Reducers

const isTokenExist = () => Boolean( localStorage.getItem('token') );

const isLogIn = (state = isTokenExist(), action) => {
  switch (action.type) {
    case SET_LOGIN:
        return true;
    case SET_LOGOUT:
        return false;
    default:
        return state;
  }
}

const token = (state = null, action) => {
  switch (action.type) {
    case SET_TOKEN:
      return (action.token)
    default:
      return state
  }
}

const reducers = withReduxStateSync(
    combineReducers({
      isLogIn,
      token
    })
)

// Store

const config = {};
const middlewares = [createStateSyncMiddleware(config)];

const store = createStore(reducers, {}, applyMiddleware(...middlewares));
initStateWithPrevTab(store);

export { store };
